export default __webpack_public_path__ + "static/media/E-transact.ad029721.png";